import React from 'react';
import styled from 'styled-components';
import { Working } from '@ui/Working';

const Wrapper = styled.div`
  padding: 16px 0 0 0;
`;

export const GenericMemo = ({ answers, selectedDocs, isStreamComplete }) => {
  if (!answers) {
    return null;
  }

  return <Wrapper>{isStreamComplete ? <></> : <Working message="Generating..." />}</Wrapper>;
};
